module.exports = __webpack_public_path__ + "static/media/Merabills.6ce5ee1c.jpg";